import { FC } from 'react';
import { DataViewEditBox, DataViewEditBoxProps } from '../../../../lib/components';
import Util from '../../../../misc/util';
import { useLocation, useNavigate } from 'react-router';

export const ProfileViewEditBox: FC<DataViewEditBoxProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <DataViewEditBox
      initMode={window.location.pathname.includes('edit') ? 'edit' : 'view'}
      {...props}
      onModeChanged={(mode) => {
        props.onModeChanged?.(mode);
        if (mode === 'edit' && !location.pathname.includes('edit'))
          navigate(Util.pushPathDir(location.pathname, 'edit'), {});
        else if (mode === 'view' && location.pathname.includes('edit')) {
          navigate(Util.popPathDir(location.pathname));
        }
      }}
    />
  );
};
